import { getOrderDeliveryStatusLabel } from '../../../../utils/order/orderDeliveryStatusDisplay';
import { getOrderListPaymentStatusLabel } from '../../../../utils/order/orderListStatusFilterOptions';
import { normalizeStoredPaymentStatus } from '../../../../utils/order/orderPaymentStatus';
import { ORDER_APPROVAL_STATUS_LABELS } from '../../../../utils/order/orderStatus';

/** 申请中待办：审批中显示「申请中」，其余与订单审批状态文案一致 */
const PENDING_APPROVAL_STATUS_LABELS = {
	...ORDER_APPROVAL_STATUS_LABELS,
	inProcessOfApproval: '申请中',
};

export const getPendingApprovalStatusLabel = (statusValue) => {
	const key = String(statusValue ?? '').trim();
	if (!key) return '';
	return PENDING_APPROVAL_STATUS_LABELS[key] ?? '';
};

/**
 * 待办列表行内：编号前圆点 / 状态列使用 tab 对应 Bootstrap subtle badge（badge-subtle-*），文案仍按业务状态。
 * @param {'delivery' | 'payment' | 'approval'} kind
 */
export const getPendingListStatusBadgeProps = (statusValue, badgeVariant, kind = 'delivery') => {
	if (!statusValue || !badgeVariant) {
		return null;
	}

	let text;
	if (kind === 'payment') {
		text = getOrderListPaymentStatusLabel(normalizeStoredPaymentStatus(statusValue)) ?? statusValue;
	} else if (kind === 'approval') {
		text = getPendingApprovalStatusLabel(statusValue);
	} else {
		text = getOrderDeliveryStatusLabel(statusValue);
	}

	if (!text || text === '-') {
		return null;
	}

	return {
		bg: badgeVariant,
		icon: 'stream',
		text,
		pill: false,
	};
};
